/*
  Time: 2019-8-21 11:16:59
  verison: 1.0
  name: WorkShopDashBoard
  author: zhangshuai

  Time: 2020-5-29 
  author: caoxiufang
  新增报警统计报告
*/
<template>
  <div class="WorkShopDashBoard mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
    <el-container style="height:100%;">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/" ref="mychild"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <!-- <el-container style="height:100%;width:100%;"> -->
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <el-main>
            <!-- <div> -->
            <div style="position: relative;"  :class="[typeof(machineListInfo) == 'undefined'?'machineMain maskMain':'machineMain']">
              <!--蒙板-->
              <div class="mask" v-show="noMachine">
                <p>{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</p>
              </div>
              <div class="mask" v-if="typeof(machineListInfo) == 'undefined'">
                <p>{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</p>
              </div>
              <div class="dlcontent">
                <!-- 下载pdf按钮 -->
                <div class="dlwarp" v-if="$store.state.isMarketAccount !=='1'">
                  <h2 class="miniTitle">{{$t('WorkShopDashBoard.dlTitle')}}</h2>
                  <div v-if="noData" class="noMachineTitle">
                    {{$t('WorkShopDashBoard.noEquipmentTableMessage')}}   
                  </div>
                  <div v-else v-loading='dlLoading'>
                    <div class="dlpagination">
                      <el-button size="mini" @click="changeTimePage('l')" icon="el-icon-arrow-left" :disabled="timeNowPage === 1"></el-button>
                      <span>{{timeNowPage}} / {{timePageSize}}</span>
                      <el-button size="mini" @click="changeTimePage('r')" icon="el-icon-arrow-right" :disabled="timeNowPage === timePageSize"></el-button>
                    </div>
                    <div class="list">
                      <div class="cardWrap" ref="wrap" >
                        <div class="card" v-for="(item, index) in steptimeList" :key="index" @mouseenter="showIndex = index" @mouseleave="showIndex = -1">
                          <p class="date"><span>{{item | formatDateManth}}</span>/<span>{{item | formatDateDay}}</span></p>
                          <p class="year">{{item | formatDateYear}}</p>
                          <!-- 下载蒙版 -->
                          <transition name="el-fade-in-linear">
                            <div class="dlMark" @click="dlPdf(item,'1')"  v-show="show && showIndex === index"><downLoadIcon title=""/></div>
                          </transition>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 下载换料pdf -->
                <div class="dlwarp dl" v-if="$store.state.isMarketAccount !=='1'">
                  <h2 class="miniTitle">{{$t('WorkShopDashBoard.dlTitle2')}}</h2>
                  <div v-if="noData" class="noMachineTitle">
                    {{$t('WorkShopDashBoard.noEquipmentTableMessage')}}   
                  </div>
                  <div v-else v-loading='dlLoading'>
                    <div class="dlpagination">
                      <el-button size="mini" @click="changeTimePage2('l')" icon="el-icon-arrow-left" :disabled="timeNowPage2 === 1"></el-button>
                      <span>{{timeNowPage2}} / {{timePageSize}}</span>
                      <el-button size="mini" @click="changeTimePage2('r')" icon="el-icon-arrow-right" :disabled="timeNowPage2 === timePageSize"></el-button>
                    </div>
                    <div class="list">
                      <div class="cardWrap" ref="ReloadWrap" >
                        <div class="card" v-for="(item, index) in changetimeList" :key="index" @mouseenter="showIndex2 = index" @mouseleave="showIndex2 = -1">
                          <p class="date"><span>{{item | formatDateManth}}</span>/<span>{{item | formatDateDay}}</span></p>
                          <p class="year">{{item | formatDateYear}}</p>
                          <!-- 下载蒙版 -->
                          <transition name="el-fade-in-linear">
                            <div class="dlMark" @click="dlPdf(item,'2')"  v-show="show2 && showIndex2 === index"><downLoadIcon title=""/></div>
                          </transition>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 产能报告 -->
                <div v-if="$store.state.isMarketAccount !=='1'" class="ProductivityReport dlwarp dltable" v-loading='ReportLoading'>
                  <div v-if="noTableData">
                    <h2 class="miniTitle">{{$t('WorkShopDashBoard.title3')}}</h2>
                  </div>
                  <div class="productivityReportTitle" v-else>
                    <div></div>
                    <h2 class="miniTitle">{{$t('WorkShopDashBoard.title3')}}</h2>
                    <el-button class="exportBtn" @click="dlPdf(0,'3')" size="medium" icon="el-icon-download">{{$t('WorkShopDashBoard.exportBtn')}}</el-button>
                  </div>
                  <div v-if="noTableData" class="noMachineTitle">
                    {{$t('WorkShopDashBoard.noEquipmentTableMessage')}}   
                  </div>
                  <div v-else>
                    <div class="datepart">
                      <!-- 切换快捷键 -->
                      <div class="changetime">
                        <el-button size="mini"  icon="el-icon-arrow-left" :disabled="leftbtnDis" @click="monthChange('last')"></el-button>
                        <span>{{timevalue|formatDateYearManth}}</span>
                        <el-button size="mini" icon="el-icon-arrow-right" :disabled="btnDis" @click="monthChange('next')"></el-button>
                      </div>
                    </div>
                    <div v-if="noMachineInFac" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</div>
                    <el-table
                      :data="tableData"
                      border
                      stripe
                      v-else
                      :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                      style="width: 100%; margin-top:15px;">
                      <el-table-column
                        fixed
                        prop="tlties"
                        :label="$t('WorkShopDashBoard.tabletitles1')"
                        width="260">
                      </el-table-column>
                      <el-table-column
                        v-for="item in tabletitle"
                        :key="item.label"
                        :prop="item.prop"
                        :label="item.label"
                        width="260">
                        <template slot-scope="scope">
                          <span class="tableLeft">{{scope.row[item.prop][0]}}</span><span class="tableRight">{{scope.row[item.prop][1]}}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <!-- 故障统计报告 -->
                <div v-show="factoryId ==2||factoryId ==17" class="ProductivityReport dlwarp" v-loading='FaultAlarmtLoading' style="margin-top: 40px;">
                    <div v-if="noTableData">
                      <h2 class="miniTitle">{{$t('WorkShopDashBoard.faultAlarmStatisticsReport')}}</h2>
                    </div>
                    <div class="productivityReportTitle" v-else>
                      <div></div>
                      <h2 class="miniTitle">{{$t('WorkShopDashBoard.faultAlarmStatisticsReport')}}</h2>
                      <el-button class="exportBtn" @click="downAsr()" size="medium" icon="el-icon-download" v-if="!noTableData">{{$t('WorkShopDashBoard.exportBtn')}}</el-button>
                    </div>
                    <div v-if="noTableData" class="noMachineTitle">
                     {{$t('WorkShopDashBoard.noEquipmentTableMessage')}}   
                    </div>
                    <div v-else>
                      <div class="datepart">
                        <div class="changetime">
                          <el-button size="mini"  icon="el-icon-arrow-left" :disabled="leftbtnDisCopy" @click="weekChange('last')"></el-button>
                          <span>{{nowYearWeek}}</span>
                          <el-button size="mini" icon="el-icon-arrow-right" :disabled="btnDisCopy" @click="weekChange('next')"></el-button>
                        </div>
                        <div style="display:inline-block;" v-if="titleStartDate !== ''">
                          <p>{{titleStartDate}} ~ {{titleEndDate}}</p>
                        </div>
                      </div>
                      <!-- 固定表格底部 -->
                      <div v-if="noMachine" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</div>
                      <el-table
                        :header-cell-style="{background:'white'}"
                        :data="policeTableData"
                        :height='heightTable'
                        :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                        border
                        v-else
                        style="width: 100%; margin-top:15px;">
                        <el-table-column
                          fixed
                          prop="tlties"
                          :label="$t('WorkShopDashBoard.event')"
                          width="280">
                          <el-table-column
                            :label="$t('WorkShopDashBoard.total')"
                            width="280">
                              <template slot-scope="scope">
                                <div>
                                  <span v-if="$store.state.lang ===1" >{{scope.row.msgZh}}</span>
                                  <span v-if="$store.state.lang ===0" >{{scope.row.msgEn}}</span>
                                </div>
                              </template>
                          </el-table-column>
                        </el-table-column>
                        <el-table-column
                          v-for="(item) in activepoliceTabletitle"
                          :key="item.label"
                          :prop="item.prop"
                          :label="item.label"
                          >
                          <el-table-column
                            :label="secondTable[item.prop]+''"
                            >
                              <template slot-scope="scope">
                                <span>{{scope.row.alarmReportList[item.prop]}}</span>
                              </template>
                          </el-table-column>
                        </el-table-column>
                        <el-table-column
                          fixed="right"
                          :label="$t('WorkShopDashBoard.total')"
                          width="130">
                          <el-table-column
                            fixed="right"
                            :label="secondTable[999]+''"
                            width="130">
                              <template slot-scope="scope">
                                <span>{{scope.row.alarmReportList[999]}}</span>
                              </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                    </div>
                </div>
              </div>
            </div>
          </el-main>
        </el-scrollbar>
      <!-- </el-container> -->
        <!-- 右侧边栏 -->
      <el-aside class="rightBox">
        <!-- <el-scrollbar class="machineWrap" style="height:100%;width:100%;"> -->
          <div class="rightBoxInfo">
            <!-- 切换车间 -->
            <el-select v-model="onevalue" @change="changeLine" 
                        class="rightBoxInfoElSelect"
                        popper-class="rightBoxInfoSelect"
                        :popper-append-to-body="true">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <!--机器列表-->
            <div class="machineListScrollbar"  v-if="machineListInfo !==undefined && machineListInfo.length > 0">
              <el-scrollbar class="machineWrap workshopWrap" style="height:97.5%;width:100%;">
                  <div class="machineList" v-for="item in machineListInfo" :key="item.id" >
                    <el-tooltip class="item" placement="left" effect="light" popper-class="tooltipEquipment">
                      <div slot="content" style="line-height:14px">
                        <div>{{$t('WorkShopDashBoard.tooltipTitle1')}}: {{item.equipmentName}}</div>
                        <div>{{$t('WorkShopDashBoard.tooltipTitle2')}}: {{item.nameZh}}</div>
                        <div>{{$t('WorkShopDashBoard.tooltipTitle3')}}: <span v-if="'contractNo' in item && item.contractNo != '' && item.contractNo !== null">{{item.contractNo}}</span><span v-else>-</span></div>
                        <div>{{$t('WorkShopDashBoard.tooltipTitle4')}}:
                          <span v-if="item.machineLifeCycle === 1">{{$t('WorkShopDashBoard.machineLifeList1')}}</span>
                          <span v-else-if="item.machineLifeCycle === 2">{{$t('WorkShopDashBoard.machineLifeList2')}}</span>
                          <span v-else-if="item.machineLifeCycle === 3">{{$t('WorkShopDashBoard.machineLifeList3')}}</span>
                          <span v-else-if="item.machineLifeCycle === 4">{{$t('WorkShopDashBoard.machineLifeList4')}}</span>
                          <span v-else-if="item.machineLifeCycle === 5">{{$t('WorkShopDashBoard.machineLifeList5')}}</span>
                          <span v-else-if="item.machineLifeCycle === 6">{{$t('WorkShopDashBoard.machineLifeList6')}}</span>
                          <span v-else-if="item.machineLifeCycle === 7">{{$t('WorkShopDashBoard.machineLifeList7')}}</span>
                        </div>
                      </div>
                      <router-link :to="{name:'EquipmentDashBoard',params:{id:item.id}}" v-show="item.machineStatus !== 0">
                      <div class="machineContent">
                        <div class="machineContent-left">
                          <div>
                            <!-- <img src="../assets/img/machine/131.jpg" class="machineContent-pic"> -->
                            <img v-if="item.id === 131" src="../assets/img/machine/131.jpg" class="machineContent-pic">
                            <img v-else-if="item.id === 211" src="../assets/img/machine/TBM211.jpg" class="machineContent-pic">
                            <img v-else-if="item.id === 201 || item.id === 202 || item.id === 196" src="../assets/img/gsq/gsqTop.jpg" class="machineContent-pic">
                            <img v-else src="../assets/img/machine/machine01.png" class="machineContent-pic">
                          </div>
                          <div >
                            <playIcon v-if="item.machineStatus === 1" title="" class="playIcon"/> 
                            <stopIcon v-if="item.machineStatus === 4" title="" class="playIcon stop"/>
                            <offlineIcon v-if="item.machineStatus === 5" title="" class="playIcon offline"/>
                            <faultIcon v-if="item.machineStatus === 3" title="" class="playIcon fault"/>
                            <standbyIcon v-if="item.machineStatus === 2" title="" class="playIcon standby"/>
                            <notConnectedIcon v-if="item.machineStatus === 0" title="" class="playIcon notConnected"/>
                            <span v-if="$store.state.lang ===0&&item.machineStatus === 1" style="color:#0bd70b;font-size:12px;">{{machintLine[item.machineStatus]}}</span>
                            <span v-else-if="$store.state.lang ===0&&item.machineStatus === 4" style="color:#4866ea;font-size:12px;">{{machintLine[item.machineStatus]}}</span>
                            <span v-else-if="$store.state.lang ===0&&item.machineStatus === 5" style="color:#808080;font-size:12px;">{{machintLine[item.machineStatus]}}</span>
                            <span v-else-if="$store.state.lang ===0&&item.machineStatus === 3" style="color:#d43030;font-size:12px;">{{machintLine[item.machineStatus]}}</span>
                            <span v-else-if="$store.state.lang ===0&&item.machineStatus === 2" style="color:#cfcf0b;font-size:12px;">{{machintLine[item.machineStatus]}}</span>
                            <span v-else-if="$store.state.lang ===0&&item.machineStatus === 0" style="color:#383838;font-size:12px;">{{machintLine[item.machineStatus]}}</span>
                            <span  v-else-if="$store.state.lang ===1&&item.machineStatus === 1" style="color:#0bd70b;font-size:12px;">{{machintLineCh[item.machineStatus]}}</span>
                            <span  v-else-if="$store.state.lang ===1&&item.machineStatus === 4" style="color:#4866ea;font-size:12px;">{{machintLineCh[item.machineStatus]}}</span>
                            <span  v-else-if="$store.state.lang ===1&&item.machineStatus === 5" style="color:#808080;font-size:12px;">{{machintLineCh[item.machineStatus]}}</span>
                            <span  v-else-if="$store.state.lang ===1&&item.machineStatus === 3" style="color:#d43030;font-size:12px;">{{machintLineCh[item.machineStatus]}}</span>
                            <span  v-else-if="$store.state.lang ===1&&item.machineStatus === 2" style="color:#cfcf0b;font-size:12px;">{{machintLineCh[item.machineStatus]}}</span>
                            <span  v-else-if="$store.state.lang ===1&&item.machineStatus === 0" style="color:#383838;font-size:12px;">{{machintLineCh[item.machineStatus]}}</span>

                            <!-- <playIcon title="" style="color:#0bd70b;font-size:16px;"/> -->
                            <!-- <span style="color:#000;">{{machintLine[item.machineStatus]}}</span> -->
                            <!-- <span style="color:#000;">运行中</span> -->
                          </div>
                        </div>
                        <div class="machineContent-right">
                          <div class="machineContent-name">
                            <p class="machineContent-tileID">{{item.equipmentName}}</p>
                            <!-- <p class="machineContent-tileID">B2 </p> -->
                            <p style="color:#505050;">{{item.currentShift +$t('WorkShopDashBoard.listLabel3')}}</p>
                            <!-- <p style="color:#505050;">甲班组</p> -->

                          </div>
                          <div class="machineContent-currentShift" >
                            <p class="machineContent-currentContent" :title="item.currentDimension" ref="aa" v-if="'currentDimension' in item">
                              {{item.currentDimension}}
                            </p>
                            <p v-else>-</p>
                          </div>
                          <div class="machineContent-currentProductivity">
                            {{$t('WorkShopDashBoard.listLabel2')}}
                            <span v-if="!item.hasOwnProperty('currentProductivity')">-</span>
                            <span>{{item.currentProductivity}}</span>
                            <!-- {{$t('WorkShopDashBoard.listLabel2')}} -->
                            <!-- <span>77</span></span> -->
                          </div>
                        </div>
                      </div>
                      </router-link>
                    </el-tooltip>
                  </div>
                
              </el-scrollbar>
            </div>
            <div v-else class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</div>
          </div>
        <!-- </el-scrollbar> -->
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import leftNav from "@/components/nav.vue"
import downLoadIcon from "vue-material-design-icons/CloudDownload.vue"
import playIcon from "vue-material-design-icons/PlayCircle.vue"
import stopIcon from "vue-material-design-icons/StopCircle.vue"
import offlineIcon from "vue-material-design-icons/LanDisconnect.vue"
import faultIcon from "vue-material-design-icons/CloseCircle.vue"
import standbyIcon from "vue-material-design-icons/PauseCircle.vue"
import notConnectedIcon from "vue-material-design-icons/EarthOff.vue"
import { formatDate } from '../assets/js/date.js'
export default {
  name: 'WorkShopDashBoard',
  components: {
    leftNav,
    downLoadIcon,
    playIcon,
    stopIcon,
    offlineIcon,
    faultIcon,
    standbyIcon,
    notConnectedIcon
  },
  data () {
    return {
      options:[],
      shopArr: [],
      shopId: null,
      fullscreenLoading: false,
      dlLoading:false,
      factoryInfo:{},
      shopInfo: {},
      // 步序报告时间列表
      steptimeList:[],
      // 换料统计报告时间列表
      changetimeList: [],
      // 将时间按照七天为一组分成二维数组
      allTimeList:[],
      // 下载列表总页数
      timePageSize: null,
      // 第一个下载列表当前页数
      timeNowPage: 1,
      show: true,
      showIndex: -1,
      // 第二个下载列表
      timeNowPage2: 1,
      show2: true,
      showIndex2: -1,
      tabletitle:[],
      tableData: [],
      // 月份
      timevalue: '',
      nowMonth: '',
      // 时间选择器逻辑
      pickerOptions: {
        disabledDate: (time) =>{
          var times = Date.now()
          return time.getTime() > times;
        }
      },
      // 机器列表数据
      machineListInfo: [],
      // 设备运行情况
      machintLine: ['Not Connected', 'running', 'standby', 'fault', 'stop', 'offline'],
      machintLineCh: ['未接入', '运行中', '待机', '故障', '停止', '离线'],
      // 设备生命周期情况
      machineLifeList: ['Manufacturing', 'Ex-factoryTesting', 'ErectionTesting', 'Using', 'Maintenance', 'TechnicalReconstruction','Write-off'],
      machineLifeListCh: ['制造中', '出厂前调试', '安装调试','使用中', '维护维修中', '技术改造中', '已报废'],
      leftbtnDis:false,
      btnDis: true,
      // 局部刷新
      ReportLoading: false,
      FaultAlarmtLoading:false,
      websock: null,
      listLoading:false,

      //报警统计报告
      weekvalue:'',// 时间选择器（周）
      nowWeek:'',
      nowYearWeek:'',
      leftbtnDisCopy:false,
      btnDisCopy: true,
      policeTabletitle:[],
      policeTableData:[],
      secondTable:[],
      // 时间选择器逻辑
      weekPickerOptions: {
        disabledDate: (time) =>{
          var times = Date.now()
          return time.getTime() > times;
        },
        firstDayOfWeek:1
      },
      startDate:'',// startDate
      endDate:'',// endDate
      heightTable:null,
      resDate: '',
      // 一周的日期
      titleStartDate:'',
      titleEndDate:'',
      // 默认显示车间
      onevalue:'',
      //有无设备
      noMachine:false,
      factoryId:null,
      //有数据时间最早月份
      firstMonth:'',
      //有数据时间最早日期（用于计算周）
      firstTime:'',
      firstWeek:'',
      //报告无数据
      noData:false,
      //当前周
      rightNowWeek:'',
      //产能报告，故障统计报告表格无数据
      noTableData:false,
      //没有配置机器
      noMachineInFac:false
    }
  },
  filters: {
    formatDateYear (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy')
    },
    formatDateManth (time) {
      var date = new Date(time)
      return formatDate(date, 'MM')
    },
    formatDateYearManth (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM')
    },
    formatDateDay (time) {
      var date = new Date(time)
      return formatDate(date, 'dd')
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    },
    activepoliceTabletitle(){
      return this.policeTabletitle.filter((item,index)=>{
          return (index<this.policeTabletitle.length-1)
      })
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.websock.close()
        this.$nextTick(()=>{
          this.getShopList()
        })
      }
    }
  },
  created() {
    // this.shopId = Number(this.$route.params.shopId)
    //this.shopId = this.$store.state.defaultShopId
    this.factoryId=Number(this.$store.state.defaultFactoryId)
    this.doHandleDate()
  },
  mounted () {
    // 获取本周一的时间 作为截止时间
    let date = new Date()
    var day = date.getDay() || 7;
    const d = new Date(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 - day))
    this.resDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    // 数据初始化
    this.getShopList()
    // this.$store.commit('authority' , this.$route.name)
  },
  destroyed () {
    this.websock.close()
  },
  methods: {
    // 获取车间列表
    getShopList() {
      this.listLoading = true
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseShop',
        params:{
          language: _this.$store.state.lang
          // shopId: _this.shopId
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if (res.data.belong === 1) {
            if(localStorage.getItem('isMarketAccount') === '1') {
              _this.$store.commit('marketAccountShop',res.data.options)
            }
           if(res.data.options !==undefined && res.data.options.length > 0 ){
              _this.noMachine=false
              _this.options = res.data.options[0].children
              if(_this.onevalue==''){
                //让默认选中的车间与登录返回的默认车间保持一致
                // _this.onevalue = _this.options[0].value
                _this.onevalue = Number(_this.$store.state.defaultShopId)
              }
              if(!_this.shopId && typeof(_this.shopId)!='undefined' && _this.shopId!=0){
                // _this.shopId=_this.options[0].value
                _this.shopId = Number(_this.$store.state.defaultShopId)
              }
              _this.fullscreenLoading = true
              _this.getFirstWithNumTime()
              _this.getShopInfo()
              _this.ReportTable()
              _this.FaultAlarmtTable()//报警统计报告
              _this.initWebSocket()
            }else{
              _this.listLoading= false
              _this.options = res.data.options
              _this.noMachine=true
              _this.$message(_this.$t('Dailyequipment.noEquipmentData'));
              _this.$store.commit('loginOut')
              _this.$router.replace({
                path: '/login'
              })
            }         
          } else{
             _this.$router.push({path: '/login', name: 'login'})
          }       
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
      
    },
    // 初始化weosocket
    initWebSocket(){
      let _this = this
      _this.fullscreenLoading = true
      _this.websock = new WebSocket("ws://" + _this.$store.state.websocketws+_this.$store.state.newroute+ "/websocket-productivityreport")
      // 接收服务器发来的消息
      _this.websock.onmessage = function (e) {
        
        var info = JSON.parse(e.data)
        if (localStorage.getItem('isMarketAccount') === '1') {
          _this.machineListInfo = info.data.splice(4)
        }else{
          _this.machineListInfo = info.data
        }
        _this.fullscreenLoading = false
      }
      // 连接建立之后执行send方法发送数据
      _this.websock.onopen = function () { 
        _this.toWebsocketSendCon()
      }
      // 连接建立失败重连
      _this.websock.onerror = function () {
        _this.websock = new WebSocket("ws://" + _this.$store.state.websocketws+_this.$store.state.newroute+ "/websocket-productivityreport")
      }
      // 关闭
      _this.websock.onclose = function () {
        _this.websock = null
      }
    },
    // 向websocket发送筛选条件
    toWebsocketSendCon () {
      let _this = this
      var param = {
        'shopId': _this.shopId,
        'accountId':_this.$store.state.authCode,
        'factoryId':_this.$store.state.factoryId,
        'route':_this.$store.state.newroute,
        'language': _this.$store.state.lang
      }
      var params = JSON.stringify(param)
      // 向服务器发送消息
      _this.websock.send(params)
    },
    // 获取当前的年份和月份
    doHandleDate() {
      var myDate = new Date();
      var tYear = myDate.getFullYear();
      var tMonth = myDate.getMonth();
      var m = tMonth + 1;
      this.nowMonth = `${tYear}-${m}`
      this.timevalue = ` ${tYear}-${m}-01 00:00:00`
      // 报警统计报告
      var tDate = myDate.getDate()//几号
      var tDay = myDate.getDay()//星期几
      if(tDay === 0){
        tDay = 7
      }
      this.nowWeek = tDate-(tDay-1)
      this.weekvalue = ` ${tYear}-${m}-${tDate}`
      this.nowYearWeek=this.getYearWeek(this.weekvalue)
      this.rightNowWeek=this.getYearWeek(this.weekvalue)
      // 获取时间区间
      let ddd = tDate-(tDay-1)//本周的周一
      let sundaySjc = new Date().setDate(ddd)//获取周一时间戳
      let saturdaySjc = new Date().setDate(ddd)+86400000*6//获取周日时间戳
      this.getTimeSection(sundaySjc,saturdaySjc)
    },
    //将日期转换为当年的第几周
    getYearWeek(date) {
      // date = formatTimebytype(date, 'yyyy-MM-dd');//将日期转换成yyyy-mm-dd格式
      date = new Date(date);
      let date2 = new Date(date.getFullYear(), 0, 1);
      let day1 = date.getDay();
      if (day1 == 0) day1 = 7;
      let day2 = date2.getDay();
      if (day2 == 0) day2 = 7;
      let d = Math.round((date.getTime() - date2.getTime() + (day2 - day1) * (24 * 60 * 60 * 1000)) / 86400000);
      let yearWeek=Math.ceil(d / 7) + 1;
      return date.getFullYear()+'第'+yearWeek+'周'
      // this.nowYearWeek=date.getFullYear()+'第'+yearWeek+'周'
    },
    changeDate(){
      var time = this.timevalue
      var timeArr = time.split('-')
      if (this.nowMonth === `${timeArr[0]}-${Number(timeArr[1])}`) {
        this.btnDis = true
      }else{
        this.btnDis = false
      }
      this.ReportTable()
    },
    // 上一个月 下一个月 按钮
    monthChange(type){
      var time = this.timevalue
      var timeArr = time.split('-')
      if (type === 'last'){
        let newTime = ''
        if (timeArr[1]-1 === 0) {
          newTime = ` ${timeArr[0]-1}-12-01 00:00:00`
        }else{
          newTime = `${timeArr[0]}-${timeArr[1]-1}-01 00:00:00`
        }
        let newTimeArr=newTime.split('-')
        if (String(`${newTimeArr[0]}-${newTimeArr[1]}`).trim() === this.firstMonth) {
          this.leftbtnDis = true
        }else{
          this.leftbtnDis = false
        }
        this.btnDis = false
        this.timevalue = newTime
        this.ReportTable()
      }else{
        // 下个月的月份
        let newTime = ''
        if (Number(timeArr[1])+1>12){
          newTime = `${Number(timeArr[0])+1}-01-01 00:00:00`
        }else{
          newTime = `${timeArr[0]}-${Number(timeArr[1])+1}-01 00:00:00`
        }
        if (String(this.nowMonth) === String(`${timeArr[0]}-${Number(timeArr[1])+1}`).trim()) {
          this.btnDis = true
        }
        if (String(`${timeArr[0]}-${Number(timeArr[1])+1}`).trim() != this.firstMonth) {
        //   this.leftbtnDis = true
        // }else{
          this.leftbtnDis = false
        }
        this.timevalue = newTime
        this.ReportTable()
      }
    },
    p(s) {
      return s < 10 ? '0' + s : s
    },
    // 触发 周选择器
    // changeWeek(){
      
    //   // 控制下个月禁选按钮
    //   var timeD = this.weekvalue
    //   var time = `${timeD.getFullYear()}-${timeD.getMonth()+1}-${timeD.getDate()}`
    //   if (time === this.resDate) {
    //     this.btnDisCopy = true
    //   }else{
    //     this.btnDisCopy = false
    //   }

    //   // 处理参数格式
    //   var myDate = this.weekvalue
    //   let x =new Date(myDate.getTime() - 86400000);
    //   var newDate = x.getDate()
    //   var tYear = x.getFullYear();
    //   var tMonth = x.getMonth();
    //   var m = tMonth + 1;
    //   var tDate = myDate.getDate()
    //   this.weekvalue = ` ${tYear}-${m}-${newDate}`

      
    //   // 获取时间区间
    //   let ddd = tDate//本周的周一
    //   let sundaySjc = myDate.setDate(ddd)-86400000//获取周日时间戳
    //   let saturdaySjc = myDate.setDate(ddd)+86400000*5//获取周日时间戳
    //   this.getTimeSection(sundaySjc,saturdaySjc)

    //   //请求数据
    //   this.FaultAlarmtTable()
    // },
    // 上一周 下一周 按钮
    weekChange(type){
      var time = this.weekvalue
      var timeArr = time.split('-')
      var timeStr = timeArr[2].slice(0,2)
      let newTime = ''
      let monD //获取周一
      if (type === 'last'){//上周
        let y = timeArr[0]//年
        let mon = timeArr[1]//月
        let monDay //每个月有多少天

        // 处理monDay
        if(mon==2 || mon==4 || mon==6 || mon==8 || mon==9 || mon==11 || mon==1){
          monDay = 31
        }else if(mon==5 || mon==7 || mon==10 || mon==12){
          monDay = 30
        }else if(mon==3){
          let Leap = ''+y/4
          if(Leap.length>3){
            monDay = 28
          }else{
            monDay = 29
          }
        }
        // 
        if (timeArr[1]-1 === 0) {
          if(timeStr < 8){
            newTime = ` ${timeArr[0]-1}-12-${monDay+Number(timeStr)-7}`
            monD = monDay+Number(timeStr)-7
          }else{
            newTime = `${timeArr[0]}-${timeArr[1]}-${Number(timeStr)-7}`
            monD = Number(timeStr)-7
          }
        }else{
          if(timeStr < 8){
            newTime = `${timeArr[0]}-${timeArr[1]-1}-${monDay+Number(timeStr)-7}`
            monD = monDay+Number(timeStr)-7
          }else{
            newTime = `${timeArr[0]}-${timeArr[1]}-${Number(timeStr)-7}`
            monD = Number(timeStr)-7
          }
        }
        this.weekvalue = newTime
        this.nowYearWeek=this.getYearWeek(this.weekvalue)
        if (this.nowYearWeek === this.firstWeek) {
          this.leftbtnDisCopy = true
        }else{
          this.leftbtnDisCopy = false
        }
        this.btnDisCopy = false
      }else{//下周
        let y = timeArr[0]//年
        let mon = timeArr[1]//月
        let monDay //每个月有多少天
        let Leap = ''+y/4
        if(Leap.length>3){
          if(mon==2){
              monDay=28
          }else if(mon==4 || mon==6 || mon==9 || mon==11){
              monDay=30
          }else{
              monDay=31
          }
        }else{//闰年
          if(mon==2){
              monDay=29
          }else if(mon==4 || mon==6 || mon==9 || mon==11){
              monDay=30
          }else{
              monDay=31
          }
        }
        if (Number(timeArr[1])+1>12){
          if(timeStr>24){
              newTime = ` ${Number(timeArr[0])+1}-01-${Number(timeStr)+7-monDay}`
              monD = Number(timeStr)+7-monDay
          }else{//${Number(timeArr[1])+1}
              newTime = `${timeArr[0]}-12-${Number(timeStr)+7}`
              monD = Number(timeStr)+7
          }
        }else{
          if( timeStr>monDay-7 ){
              newTime = `${timeArr[0]}-${Number(timeArr[1])+1}-${Number(timeStr)+7-monDay}`
              monD = Number(timeStr)+7-monDay
          }else{
              newTime = `${timeArr[0]}-${Number(timeArr[1])}-${Number(timeStr)+7}`
              monD = Number(timeStr)+7
          }
        }

        // 未到时间 禁用
        var modelArr = time.split(' ')
        //获取周日时间戳
        let huoqu = new Date(modelArr[1]).getTime()+86400000*7
        let nowDate =formatDate( new Date(huoqu), 'yyyy-M-d')
        let timeArray = nowDate.split('-')
        let timeyear = timeArray[0]
        let timemonth = timeArray[1]
        let timeday = timeArray[2]
        if(timemonth<10){
            timemonth = '0' + timemonth
        }
        if(timeday<10){
            timeday = '0' + timeday
        }
        nowDate= timeyear+'-' +timemonth+'-'+timeday
        if (nowDate >= this.resDate) {
          this.btnDisCopy = true
        }
        this.weekvalue = newTime
        this.nowYearWeek=this.getYearWeek(this.weekvalue)
        if (String(this.nowYearWeek) === String(this.rightNowWeek)) {
          this.btnDisCopy = true
        }
        if (this.nowYearWeek != this.firstWeek) {
          this.leftbtnDisCopy = false
        }
      }
      // 获取时间区间
      let ddd = monD//本周的周一
      let sundaySjc = new Date(newTime).setDate(ddd)//获取周一时间戳
      let saturdaySjc = new Date(newTime).setDate(ddd)+86400000*6//获取周日时间戳
      this.getTimeSection(sundaySjc,saturdaySjc)
      // this.weekvalue = newTime
      // this.getYearWeek(this.weekvalue)
      this.FaultAlarmtTable()
    },
    // 获取车间信息&下载pdf列表
    getShopInfo(){
      let _this = this
      _this.dlLoading=true
      // 获取车间信息
      function getinfo() {
        return _this.axios({
                method: 'get',
                url: '/url/selectFactoryShop',
                params:{
                  shopId: _this.shopId
                }
              })
      }
      // 获取pdf时间列表
      function getDateList() {
        return _this.axios({
                method: 'post',
                url: '/url/getUpDownTime',
                params:{
                  shopId: _this.shopId
                }
              })
      }
      this.axios.all([getinfo(), getDateList()])
        .then( _this.axios.spread (function(res, list){
        // 车间信息赋值
        if (res.data.success === 'true'){
          _this.shopArr = [res.data.factory.id, res.data.shop.id]
          _this.factoryInfo = res.data.factory
          _this.shopInfo = res.data.shop
          //_this.onevalue=res.data.shop.id
          _this.listLoading = false
        }else {
          _this.$message.error('shopInfo loading failed')
        } 
        // pdf时间列表计算赋值
        if (list.data.success === 'true'){
          if('timeList' in list.data){
            _this.noData=false
            _this.timeList = list.data.timeList
            let total = list.data.timeList.length/7
            if (Number.isInteger(total)) {
              _this.timePageSize = total
            } else {
              _this.timePageSize = Number.parseInt(total) + 1
            }
            // 将时间按照七天为一组分成二维数组
            _this.allTimeList =[]
            for (let index = 0; index < _this.timePageSize; index++) {
              let sevenDay = list.data.timeList.splice(0,7)
              _this.allTimeList.push(sevenDay)
            }
            _this.steptimeList=_this.allTimeList[0]
            _this.changetimeList=_this.allTimeList[0]
          }else{
            _this.noData=true
          }
        }else {
          _this.$message.error('TimeList loading failed')
        }
        _this.dlLoading=false
      }))
    },
  
    // 改变车间触发
    changeLine(item){
      // this.shopId = item.value
      // this.onevalue = item.value
      // this.shopArr[1]=item.value
      // this.$router.push({
      //   name: 'WorkShopDashBoard',
      //   params: {
      //     shopId:this.shopArr[1]
      //   }
      // })
      // this.$parent.reload()
      
      this.shopId = item
      this.onevalue = item
      this.shopArr[1]=item
      //由于反显默认选中的车间改为根据defaultShopId进行，暂时取消切换车间后，默认shopid随之改变效果---2021.5.18lxx
      // this.$store.state.defaultShopId=this.shopArr[1]
      this.websock.close()
      
      this.$nextTick(()=>{
          this.doHandleDate()
          this.getShopList()
        })
      // this.$parent.reload()
    },
    // 下载pdf翻页
    changeTimePage(d){
      if (d === 'l'){
        this.timeNowPage-=1
      }else{
        this.timeNowPage+=1
      }
      this.steptimeList = this.allTimeList[this.timeNowPage-1]
    },
    changeTimePage2(d){
      if (d === 'l'){
        this.timeNowPage2-=1
      }else{
        this.timeNowPage2+=1
      }
      this.changetimeList = this.allTimeList[this.timeNowPage2-1]
    },
    // 下载pdf
    dlPdf(t,num){
      let timeStr = formatDate(new Date(t), 'yyyy-MM-dd')
      let signTime = new Date().getTime()
      this.$store.commit('nowsign', signTime)
      if ( num === '1') {
        // 设备报告下载
        window.open(`/download/daochuNum?factoryId=${this.shopArr[0]}&shopId=${this.shopArr[1]}&dateTime=${timeStr}&language= ${this.$store.state.lang}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`, '_blank')
      }else if (num === '2'){
        // 换料报告现在
        window.open(`/url/getReloadingStatisticReport?factoryId=${this.shopArr[0]}&shopId=${this.shopArr[1]}&dateTime=${timeStr}&language= ${this.$store.state.lang}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`, '_blank')
      } else if (num === '3'){
        //window.open(`/url/excelExportProductivityReport?shopId=${this.shopArr[1]}&date=${this.timevalue}&language= ${this.$store.state.lang}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`, '_blank')
        if (this.tableData == null || this.tableData.length === 0){
          this.$message.error(this.$t('gantt.error'));
        }else{
          window.open(`/url/excelExportProductivityReport?shopId=${this.shopArr[1]}&date=${this.timevalue}&language= ${this.$store.state.lang}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`, '_blank')
        }
      }
    },
    //获取产能报告&故障统计报告有数据的最早时间
    getFirstWithNumTime(){
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/getFirstTireTime',
        params:{
          shopId: _this.shopId
        }
      }).then(function(res){
        if('time' in res.data){
          let firstTime=res.data.time
          // leftbtnDis
          let firstDate = new Date(firstTime);
          let fYear = firstDate.getFullYear();
          let fMonth = firstDate.getMonth();
          let m = fMonth + 1;
          _this.firstMonth = `${fYear}-${m}`
          // _this.firstMonth = `2021-1`
          
          let valueArr = _this.timevalue.split(' ')[1].split('-')
          let nowValue=`${valueArr[0]}-${Number(valueArr[1])}`
          if (nowValue === _this.firstMonth) {
            _this.leftbtnDis = true
          }else{
            _this.leftbtnDis = false
          }
          let fDate = firstDate.getDate()//几号
          let fDay = firstDate.getDay()//几号
          let newTime=''
          let weekFirstDay = new Date(firstTime - (fDay - 1) * 86400000)
          let firstMonth = Number(weekFirstDay.getMonth()) + 1
          if (firstMonth < 10) {
              firstMonth = '0' + firstMonth
          }
          let weekFirstDays = weekFirstDay.getDate();
          if (weekFirstDays < 10) {
              weekFirstDays = '0' + weekFirstDays;
          }
          newTime= weekFirstDay.getFullYear() + '-' + firstMonth + '-' + weekFirstDays;
          _this.firstWeek=_this.getYearWeek(newTime)
          if (_this.nowYearWeek === _this.firstWeek) {
            _this.leftbtnDisCopy = true
          }else{
            _this.leftbtnDisCopy = false
          }
        }else{
          _this.noTableData=true
        }
      })
    },
    // 生产力报告表格数据
    ReportTable(){
      let _this = this
      this.ReportLoading = true
       this.axios({
        method: 'post',
        url: '/url/productivityReport',
        params:{
          language: _this.$store.state.lang,
          shopId: _this.shopId,
          date: _this.timevalue
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.noMachineInFac=false
          //循环将表格第一行数据拼入数据中
          let titlesArr = res.data.leftTitle
          for (const [index , item] of res.data.tableData.entries()) {
            item.tlties = titlesArr[index]
          }
          _this.tabletitle = res.data.tabletitle
          _this.tableData = res.data.tableData
        }else{
          _this.noMachineInFac=true
        }
      }).then(function(){
        _this.ReportLoading = false
      })
    },
    // 报警统计表格数据
    FaultAlarmtTable(){
      let _this = this
      this.FaultAlarmtLoading = true
       this.axios({
        method: 'post',
        url: '/url/getAlarmStatisticsReport',
        params:{
          language: _this.$store.state.lang,
          shopId: _this.shopId,
          date: _this.weekvalue,
          dataType:1
    }
    
      }).then(function(res){
        if (res.data.success === 'true') {
            _this.policeTabletitle = res.data.tableTitle
            res.data.leftTitle.forEach(item=>{//将0变成''
              for(let key in item.alarmReportList){
                if(item.alarmReportList[key] === 0){
                  item.alarmReportList[key] = ''
                }
              }
            })
            _this.policeTableData = res.data.leftTitle
            if(_this.policeTableData){
              _this.heightTable = '300'
            }
            // 合计（行）
            _this.secondTable = res.data.totalDate.alarmReportList
            _this.titleStartDate=res.data.startTime
            _this.titleEndDate=res.data.endTime
  }
      }).then(function(){
        _this.FaultAlarmtLoading = false
      })
    },
    // 下载 报警统计表格数据
    downAsr(){
      let signTime = new Date().getTime()
      this.$store.commit('nowsign', signTime)
      // 设备报告下载
      window.open(`/download/alarmStatisticsReportExportLog?dataType=1&shopId=${this.shopArr[1]}&date=${this.weekvalue}&language= ${this.$store.state.lang}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`, '_blank')
    },
    // 获取时间区间
    getTimeSection(sundaySjc,saturdaySjc){
      // 获取start周日
      let sundayStr = new Date(parseInt(sundaySjc)).toLocaleString()//时间戳转成日期格式字符串
      let arr = sundayStr.split(' ')//去掉时分秒
      let start = arr[0].split('/')//获取年月日
      let startArr = start.map(item=>{//补0
        if(Number(item)<10){
          item = '0'+ item
}
        return item
      })
      // 获取end周六
      let saturdayStr = new Date(parseInt(saturdaySjc)).toLocaleString()//时间戳转成日期格式字符串
      let arr2 = saturdayStr.split(' ')//去掉时分秒
      let end = arr2[0].split('/')//获取年月日
      let endArr = end.map(item=>{//补0
        if(Number(item)<10){
          item = '0'+ item
        }
        return item
      })
      this.startDate = startArr
      this.endDate = endArr
    }
  }
}
</script>
<style scoped>
.machine{
  height: 100%;
  min-width: 1365px!important;
}
.machineInfo{
 overflow: hidden;
 box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
 border-radius: 4px;
 border:none;
}
.machineInfo .title{
  overflow: hidden;
  padding: 20px 25px;
  background-color: rgba(255, 255, 255, 0.7);
  border-bottom: 1px solid #e8e8e8;
  display:flex;
  align-items: center;
  justify-content: space-between;
}
.machineInfo .title .titlename{
  display:flex;
  flex-wrap: wrap;
  font-size: 24px;
  color: #525f7f;
  line-height: 40px;
  width: calc(100% - 530px);
}
.machineInfo .title p span{
  margin-right: 15px;
}
.machineInfo .rightWrap{
  float: right;
  display:flex;
  align-items: center;
}
.machineMain{
  width:98%;
  /* min-height: 100%; */
  background-color: #fafafa;
  margin: auto;
  margin-left: 2%;
  border-radius: 6px;
  /* padding:3%; */
  box-sizing:border-box;
}
.maskMain{
  padding:0;
}
.mask{
  display: block;
  position: absolute;
  /* top: 84px; */
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: 30px;
  word-wrap: break-word;
  padding-top: 10%;
  box-sizing: border-box;
}
.dlcontent{
  padding: 3%;
}
.rightWrap .everyWorkShop{
    border: 1px solid #409EFF;
    border-radius: 10px;
    padding: 8px 10px;
    color:#409EFF;
    margin-right:10px;
    cursor: pointer;
}
.rightWrap .activeWorkShop{
  background:#409EFF;
  color:#fff;
}
.miniTitle{
  font-weight: bold;
  font-size: 18px;
  /* margin-bottom: 20px;
  display: inline-block; */
  line-height: 20px;
}
.dlwarp{
  /* margin-top: 40px; */
  position: relative;
  overflow: hidden;
  background-color: #e5eef7;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  border:none;
  width: 100%;
  padding:20px;
  text-align: center;
  box-sizing:border-box;
}
.dl{
  margin-top: 40px;
  background-color: #ede8f8;
}
.dltable{
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}
/* .dlreport{
  height:440px;
} */
.dlwarp .dlpagination{
  float: right;
  margin: 5px 0 8px 0;
}
.dlpagination span,  .changetime span{
  font-size: 14px;
  margin: 0 10px;
}
.dlpagination button, .changetime button{
  padding: 7px;
}
.dlwarp .list{
  width: 100%;
  overflow: hidden;
  height: 105px;
  position: relative;
}
.productivityReportTitle{
  display: flex;
  justify-content: space-between;
}
.list .cardWrap{
  width: 100%;
  position: absolute;
  top: 0;
  left: 52%;
  transform: translateX(-50%);
}
.list .cardWrap .card{
  width: 12.3%;
  height: 100px;
  background-color: #fff;
  float: left;
  position: relative;
  text-align: center;
  padding: 15px 0;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.15);
  margin-right: 1.5%;
  margin-bottom: 10px;
}
.card .date{
  font-size: 2.5em;
  color: #ccc;
}
.card .date span{
  color: rgba(24, 144, 255, 1);
}
.card .year,.card .id{
  font-size: 1.1em;
  font-weight: bold;
}
.card .year{
 margin: 3px 0;
}
.card .id{
  color: rgba(118, 118, 118, 1)
}
.card .dlMark{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  line-height: 100px;
  background-color: rgba(255,255,255,0.8)
}
.card .dlMark span{
  font-size: 38px;
  color:  rgba(24, 144, 255, 1);
}

/* 新增车间列表 */
.listWrap{
  background: #f6f9fc;
  padding: 15px 0 20px;
  
}
.listBorder{
  display: flex;
  flex-flow: wrap;
  max-width: 1610px;
  width: max-content;
  padding-left: 10px;
}
.listBorder-copy{
  display: flex;
  flex-flow: wrap;
  max-width: 1610px;
  width: max-content;
  padding-left: 10px;
}
.listWrap .lists{
  width: 390px;
  height: 80px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background:#fff;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  font-size: 12px;
}
/* .listWrap .lists-copy{
  width: 380px;
} */
.listWrap .lists img{
  width: 80px;
  height: 80px;
}
.listWrap .lists .innerLeft{
  padding: 5px 0 5px 5px;
  box-sizing: border-box;
  width: 200px;
}
/* .lists .innerLeft .tileID{
  font-size: 14px;
  color: #000;
  font-weight: bold;
  white-space: nowrap;
} */
.lists .innerLeft .tileID span{
  color: rgba(133, 133, 133, 1)
}
.lists .innerLeft .cycleTime{
  color: rgba(133, 133, 133, 1);
  margin: 6px 0;
}
.listWrap .lists .innerRight{
  width: 210px;
  padding: 5px 5px 5px 0;
  text-align: right;
  box-sizing: border-box;
}
.listWrap .lists .innerRight p{
  color: rgba(128, 128, 128, 1);
}
.listWrap .lists .innerRight p:nth-child(1){
  color: rgba(211, 212, 214, 1);
  font-weight: bold;
  font-size:12px;
}

/* 产能表格样式 */
.tableLeft{
  display: inline-block;
  width: calc(50% - 1px);
  border-right: 1px solid #EBEEF5
}
.tableRight{
  padding-left: 10px;
}
.ProductivityReport .timePicker{
  width: 125px;
  margin: 0 20px;
}
.exportBtn{
  width: 80px;
  padding: 8px 10px;
  font-size: 13px;
  
}
.changetime, .ProductivityReport .miniTitle{
  display: inline-block;
}
.ProductivityReport .datepart{
  /* float: right; */
  display: flex;
  flex-direction: row-reverse;
  margin: 10px 0 0 0;
  align-items: center;
}
/* .currentProductivity{
  margin: 10px 0;
} */
.listLink{
  margin-right: 10px;
  margin-bottom:10px;
  width: 392px;
  height: 82px;
}

/* 报警统计报告 */
.ProductivityReport .weekPicker{
  width: 160px;
}
.noMachineTitle{
    color:#909399;
    line-height: 100px;
    text-align: center;
}
/*右侧侧边栏机器信息*/
.rightBox{
  height: 100%;
  padding:20px 15px;
}
.rightBoxInfo{
  width: 270px;
  background-color: #fafafa;
  border-radius: 6px;
  min-height: 100%;
  height: 100%;
  padding:20px 15px;
  box-sizing:border-box;
  text-align: center;
}
.machineContent{
  display: flex;
  background-color: #e5eef7;
  height:95px;
  border-radius: 8px;
  padding:10px 8px;
  box-sizing:border-box;
  width: 100%;
  text-align: left;
  margin-top: 10px;
  /* justify-content: space-between; */
}
.machineContent-pic{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  /* margin-left: 30px; */
  /* border: 1px solid #cfd0d1; */
}
.playIcon{
  color: #0bd70b;
  font-size:16px;
}
.stop{
    color:#4866ea;
}
.offline{
    color:#808080;
}
.fault{
    color:#d43030;
}
.standby{
    color:#cfcf0b;
}
.notConnected{
    color:#383838;
}
.machineListScrollbar{
  overflow: hidden;
  height: 95%;
  margin-top: 10px;
}
.machineContent-right{
  /* margin-left: 8px; */
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: #000;
}
.machineContent-tileID{
  font-size: 14px;
  color: #000;
  font-weight: bold;
  white-space: nowrap;
}
.machineContent-currentShift{
  font-size: 13px;
  line-height: 18px;
  /* height: 30px; */
  font-weight: bold;
  overflow:hidden;
  margin-bottom: 9px;
  color: #000;
}
.machineContent-currentContent{
  height: 17px;
  position: relative;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.machineContent-currentProductivity{
  font-size: 12px;
}
/* .machineContent-currentContent:hover{
  animation-name: example;
  animation-duration: 2s;
} */
/* @keyframes example {
  0%   { overflow:unset;left:0px; top:0px;}
  100% { overflow:unset;left:calc(-100% - 157px); top:0px;}
} */
.machineContent-left{
  width: 35%;
}
.machineContent-name{
  display: flex;
  justify-content: space-between;
  /* line-height: 30px; */
  margin-bottom: 10px;
}
/* .noMachineTitle{
  color:#909399;
  line-height: 100px;
  text-align: center;
} */
</style>

